import { Box, Button, HStack, Input, Text } from "@chakra-ui/react";
import { ChangeEvent } from "react";
import SubTitle from "./SubTitle";

interface ShippingInputProps {
    title?: string;
    name: string;
    phone: string;
    addressData: {
        zonecode: string;
        roadAddress: string;
        detailAddress: string;
        sido: string;
        sigungu: string;
        sigunguCode: string;
    };
    callBackName: (e: ChangeEvent<HTMLInputElement>) => void;
    callBackPhone: (e: ChangeEvent<HTMLInputElement>) => void;
    callBackSearchPostCode: () => void;
    callBackDetailAddress: (e: ChangeEvent<HTMLInputElement>) => void;
}

const ShippingInput = (props: ShippingInputProps) => {
    const {
        title,
        name,
        phone,
        addressData,
        callBackName,
        callBackPhone,
        callBackSearchPostCode,
        callBackDetailAddress,
    } = props;
    return (
        <Box>
            {props.title && <SubTitle>{props.title}</SubTitle>}
            <Text fontSize={"0.813rem"} fontWeight="semibold" mb={"0.5rem"}>
                이름*
            </Text>
            <Input
                h="3.375rem"
                fontSize={"0.938rem"}
                fontWeight="medium"
                focusBorderColor={"gray.100"}
                borderRadius="sm"
                _placeholder={{ color: "#bdbdbd" }}
                type="text"
                placeholder="최소 두 글자 이상 입력해 주세요."
                mb="1.5rem"
                value={name}
                onChange={callBackName}
            />
            <Text fontSize={"0.813rem"} fontWeight="semibold" mb="0.5rem">
                전화번호*
            </Text>
            <Input
                h="3.375rem"
                fontSize={"0.938rem"}
                fontWeight="medium"
                focusBorderColor={"gray.100"}
                borderRadius="sm"
                _placeholder={{ color: "#bdbdbd" }}
                type="tel"
                placeholder="010-1234-5678"
                mb="1.5rem"
                value={phone}
                onChange={callBackPhone}
            />
            <Text fontSize={"0.813rem"} fontWeight="semibold" mb="0.5rem">
                주소*
            </Text>
            <HStack mb="0.5rem">
                <Input
                    h="3.375rem"
                    fontSize={"0.938rem"}
                    fontWeight="medium"
                    bg="#fafafa"
                    color="#212121"
                    _disabled={{ borderColor: "#eee" }}
                    borderRadius="sm"
                    _placeholder={{ color: "#bdbdbd" }}
                    type="text"
                    disabled
                    placeholder="우편번호"
                    value={addressData?.zonecode}
                />
                <Button
                    h="3.375rem"
                    w="6rem"
                    fontSize={"0.875rem"}
                    fontWeight="semibold"
                    color={"#757575"}
                    bgColor="white"
                    border={"1px"}
                    borderColor="#eeeeee"
                    borderRadius="sm"
                    onClick={callBackSearchPostCode}
                >
                    <Text>주소검색</Text>
                </Button>
            </HStack>
            <Input
                h="3.375rem"
                fontSize={"0.938rem"}
                fontWeight="medium"
                bg="#fafafa"
                color="#212121"
                _disabled={{ borderColor: "#eee" }}
                borderRadius="sm"
                _placeholder={{ color: "#bdbdbd" }}
                type="text"
                placeholder="기본주소"
                disabled
                mb="0.5rem"
                value={addressData?.roadAddress}
            />
            <Input
                h="3.375rem"
                fontSize={"0.938rem"}
                fontWeight="medium"
                focusBorderColor={"gray.100"}
                borderColor={"#eee"}
                borderRadius="sm"
                _placeholder={{ color: "#bdbdbd" }}
                type="text"
                placeholder="상세주소"
                mb="0.5rem"
                value={addressData?.detailAddress}
                onChange={callBackDetailAddress}
            />
        </Box>
    );
};
export default ShippingInput;
